const routes = {
  home: '/',
  signin: '/signin',
  dashboard: '/dashboard',
  products: '/products',
  billing: '/billing',
  account: '/account'
}

export default routes
